import React from 'react';
import { onKeyDown } from '../../../../service';
import classes from './DynamicContentCard.module.css';

const DynamicContentCard = ({ contentList, isMarkedFunc, onClick, onClickPropertyName }) => {

    const handleOnClick = (e, property) => {
        e.stopPropagation()
        onClick(property)
    }

    return (
        <>
            {contentList.slice(0, 3).map((c, index) => (
                <div key={index}>
                    <div className={classes.Content}>
                        <div className={`${classes.EmptyMark} ${isMarkedFunc && isMarkedFunc(c) ? classes.Mark : ""}`}></div>
                        {c.name && <div className={classes.Name} onClick={(e) => handleOnClick(e, c[onClickPropertyName])} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleOnClick(e, c[onClickPropertyName]))}>{c.name}</div>}
                    </div>
                    {index < Math.min((contentList.length - 1, 2)) &&
                        <div className={classes.ContentDivider} />}
                </div>
            ))}
        </>
    );
}

export default DynamicContentCard;